import axios from "axios";

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL;

export const getAudioTracks = async (categoryId) => {
    try {
        const response = await axios.get(`${API_BASE_URL}/audio-tracks`, {
            params: {
                category_id: categoryId,
            },
        });

        return response.data;
    } catch (error) {
        console.error("Error fetching audio tracks:", error.response?.data || error.message);
        throw error;
    }
};

export const createAudioTrack = async (audioData) => {
    try {
        const response = await axios.post(
            `${API_BASE_URL}/audio-tracks`,
            audioData,
            {
                headers: {
                    "Content-Type": "application/json",
                },
            }
        );

        return response.data;
    } catch (error) {
        console.error("Error creating audio track:", error.response?.data || error.message);
        throw error;
    }
};